import api from './api';

export type SiteControllerState = 'online' | 'warning' | 'offline';

export interface SiteController {
  id: string;
  siteId: string;
  name: string;
  ipAddress?: string;
  apiKey: string;
  state: SiteControllerState;
  /** Present when state is warning — backend-populated summary of the issue. */
  stateDescription?: string | null;
  lastSeen?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSiteControllerData {
  siteId: string;
  name: string;
  ipAddress?: string;
}

export interface UpdateSiteControllerData {
  name?: string;
  ipAddress?: string;
}

export interface SyncControllerStats {
  areasCreated: number;
  areasUpdated: number;
  areasDeleted: number;
  presetsCreated: number;
  presetsUpdated: number;
  presetsDeleted: number;
  lightsCreated: number;
  lightsUpdated: number;
  lightsDeleted: number;
}

export const siteControllersApi = {
  getBySite: async (siteId: string): Promise<SiteController[]> => {
    const { data } = await api.get(`/site-controllers/site/${siteId}`);
    return data;
  },

  getById: async (id: string): Promise<SiteController> => {
    const { data } = await api.get(`/site-controllers/${id}`);
    return data;
  },

  create: async (data: CreateSiteControllerData): Promise<SiteController> => {
    const { data: response } = await api.post('/site-controllers', data);
    return response;
  },

  update: async (id: string, data: UpdateSiteControllerData): Promise<SiteController> => {
    const { data: response } = await api.put(`/site-controllers/${id}`, data);
    return response;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/site-controllers/${id}`);
  },

  sync: async (id: string): Promise<SyncControllerStats> => {
    const { data } = await api.post(`/site-controllers/${id}/sync`);
    return data;
  },
};
